import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import classnames from 'classnames';

import Map from './map/components/map/Map';
import Wizard from './app/components/wizard/Wizard';
import { useMobile } from './common/components/responsive/Responsive';

import './App.scss';
import {
  AppConfig,
  AppConfigProvider,
  loadAppConfig,
} from './common/contexts/app-config';
import { useMount } from 'react-use';
import { LoadingSpinner } from './common/components/controls/loading-spinner/LoadingSpinner';

const App = () => {
  const isMobile = useMobile();
  const [appConfig, setAppConfig] = useState<AppConfig | undefined>();
  useMount(() => {
    loadAppConfig().then((config) => setAppConfig(config));
  });

  return appConfig ? (
    <AppConfigProvider appConfig={appConfig}>
      <div className={classnames('app', isMobile && 'mobile')}>
        <Map />
        <Wizard className="app__wizard" />
      </div>
    </AppConfigProvider>
  ) : (
    <div className="spinner">
      <LoadingSpinner delayed />
    </div>
  );
};
export default hot(module)(App);
